import { AxiosError, isAxiosError } from 'axios';

export type HeaderErrorType = 'auth' | 'not_found' | 'server' | 'network' | 'unknown';

export interface HeaderApiError {
  type: HeaderErrorType;
  status?: number;
  message?: string;
}

export function resolveHeaderApiError(error: unknown): HeaderApiError | null {
  if (!error) {
    return null;
  }

  if (isAxiosError(error)) {
    const axiosError = error as AxiosError<{ error?: string; message?: string }>;
    const status = axiosError.response?.status;
    const payloadMessage = axiosError.response?.data?.message ?? axiosError.response?.data?.error;

    if (status === 401) {
      return { type: 'auth', status };
    }

    if (status === 404) {
      return { type: 'not_found', status };
    }

    if (status === 0) {
      return { type: 'network', status };
    }

    return {
      type: 'server',
      status,
      message: payloadMessage ?? axiosError.message,
    };
  }

  if (error instanceof Error) {
    return { type: 'unknown', message: error.message };
  }

  return { type: 'unknown', message: String(error) };
}

